const resolveApiBaseUrl = (useEmulator, apiTarget, apiUrl) => {
  if (useEmulator === 'true') return 'http://127.0.0.1:8000';
  if (apiTarget === 'dev') return 'https://dev.api.gastronaut.ai';
  if (apiTarget === 'beta') return 'https://beta.api.gastronaut.ai';
  return apiUrl || 'https://api.gastronaut.ai';
};

module.exports = { resolveApiBaseUrl };
